<style lang="less" scoped>
  .drug-add-cover {
    width: 100%;

    .drug-add-row {
      display: flex;
      align-items: center;
      margin-bottom: 15px;

      .drug-add-title {
        min-width: 70px;
        padding-right: 10px;
      }

      .drug-add-column {
        flex: 1;
      }
    }
  }
  .description {
    color: gray;
    padding-left: 10px;
  }
</style>

<template lang="pug">
  #adminDrugAdd.admin-container
    .admin-title-cover
      div.admin-title 약재 추가 (or 수정)
    form.drug-add-cover(@submit.prevent="submit()")
      .drug-add-row
        .drug-add-title
          strong 약재명
        .drug-add-column
          el-input(type="text" v-model="name")
      .drug-add-row
        // .drug-add-title
        //   strong 원산
        // .drug-add-column
        //   el-input(type="text" v-model="origin")
        .drug-add-title
          strong 설명
        .drug-add-column
          el-input(type="text" v-model="description")
      .drug-add-row
        .drug-add-title
          strong g당 가격
        .drug-add-column
          el-input(type="text" v-model="price")
      .drug-add-row
        .drug-add-title
          strong 재고 여부
        .drug-add-column
          span
            el-switch(
              :value="unavailable",
              @change="changeUnavailable")
          span.description 활성화는 재고가 없음을 의미합니다.
      .drug-add-row
        .drug-add-title
        .drug-add-column
          el-button(type="default" native-type="submit") 저장
          el-button(type="default" @click="deleteIngredient") 삭제
</template>

<script>
export default {
  props: ['index'],
  data() {
    return {
      drugId: null,
      isOpenSelectTypeDialog: true,
      name: null,
      description: null,
      price: null,
      unavailable: true,
    };
  },
  methods: {
    async deleteIngredient() {
      if (this.drugId) {
        await this.$http.delete('/ingredients/'.concat(this.drugId));
        alert('데이터를 삭제했습니다.');
        this.$route.push('/admin/drug');
      } else {
        alert('삭제할 정보를 받아오지 못했습니다.');
      }
    },
    async submit() {
      // 전송
      const payload = {
        name: this.name,
        description: this.description,
        price: this.price,
        unavailable: this.unavailable,
      };

      if (!this.drugId) {
        await this.$http.post('/ingredients', payload);
      } else {
        await this.$http.put('/ingredients/'.concat(this.drugId), payload);
      }
      this.$router.push('/admin/drug');
    },
    changeUnavailable(value) {
      this.unavailable = value;
    },
  },
  async mounted() {
    // 기존 정보를 수정할 경우, 데이터를 불러옵니다.
    this.drugId = this.$route.params.drugId;
    const { data } = await this.$http.get('/ingredients/'.concat(this.drugId));
    this.name = data.name;
    this.description = data.description;
    this.price = data.price;
    this.unavailable = data.unavailable;
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/drug_add.vue